import React from 'react'
import {Autocomplete, TextField} from '@mui/material'

interface SearchOrCreateDropdownProps {
  options: string[]
  value?: string
  onChange: (value: string) => void
  placeholder?: string
  label?: string
  width?: number | string

  // Style-only: allow callers to match other inputs.
  // Default stays as before to avoid changing look globally unless opted in.
  variant?: 'outlined' | 'standard'
}

export const SearchOrCreateDropdown: React.FC<SearchOrCreateDropdownProps> = ({
  options,
  value,
  onChange,
  placeholder = 'Select Option',
  label = 'Select Option',
  width,
  variant = 'outlined',
}) => {
  const handleInputChange = (
    _: React.SyntheticEvent,
    newValue: string,
    reason: 'input' | 'reset' | 'clear' | 'blur' | 'selectOption' | 'removeOption',
  ) => {
    if (reason !== 'input') {
      return
    }
    onChange(newValue)
  }

  const handleChange = (_: React.SyntheticEvent, newValue: string | null) => {
    onChange(newValue ?? '')
  }

  return (
    <Autocomplete
      freeSolo
      options={options}
      value={value ?? ''}
      onChange={handleChange}
      onInputChange={handleInputChange}
      sx={{width: width ?? 220}}
      renderInput={(params) => <TextField {...params} label={label} placeholder={placeholder} variant={variant} />}
    />
  )
}
